import {BlockPartner} from "./BlockPartner";

export const PluginPartner = {
	init(): void {
		const partnerBlocks = document.querySelectorAll( '.wv-partners' ) as NodeListOf<HTMLElement>;
		partnerBlocks.forEach( ( block: HTMLElement ): void => {
			BlockPartner( block );
		} );
	}
}
